import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { AppState, Actions, store, PanelState } from '../../appredux'
import CONFIG from '../../cfg/config';
import { MenuService, AsortGrupyWiersz, BlobService, Blob } from '../../api';

import KartaDanie from './KartaDanie';

import AppsIcon from '@mui/icons-material/Apps';
import MenuIcon from '@mui/icons-material/Menu';

import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid, IconButton } from '@material-ui/core';

type ZamowienieState = {
  headers? : any,
  headersIds? : any,
  blobData: Blob[],
  view: number,

  item: AsortGrupyWiersz,
}

type ZamowienieProps = {
    classes? : any,
    page? : any,
}

class Zamowienie extends React.Component<ZamowienieProps, ZamowienieState> {
    constructor(props : any) {
        super(props, {});
        this.state = { 
          headers: [],
          headersIds: [],
          blobData: [],
          view: 1,

          
          item: new AsortGrupyWiersz(),
        } 
      }   
    
       componentDidMount() {
        this.getData();
       } 
       componentDidUpdate(prevProps: ZamowienieProps) {
        if(prevProps.page.menuItems !== this.props.page.menuItems){
          this.getData();
        }  
        if(prevProps.page.selectedMenuItem !== this.props.page.selectedMenuItem){
          this.getData();
        }
        // if(prevProps.page.asort.length !== this.props.page.asort.length){
        //   this.getBlob();
        // }
      }

      setItem = (item: AsortGrupyWiersz) => {
        if(this.state.item.asort_id !== item.asort_id) this.setState({item: item})
      }

      setView = (view: number) => {
        if(this.state.view !== view) this.setState({view: view})
      }

      flat(input : any, depth = 1, stack = Array())
      {
          for (let item of input)
          {
              if (item instanceof Array && depth > 0)
              {
                  this.flat(item, depth - 1, stack);
              }
              else {
                  stack.push(item);
              }
          }

          return stack;
      }
    
      getData = () => {
        let id = this.props.page.selectedMenuItem;
        //let data = this.props.page.asortHeaders.filter((e: any) => e.menu_id == id)
        let data = this.props.page.asortHeaders.filter((e: any) => e.menu_id == id && e.menu_lp === 1)
        let ids: any = [];
        data.forEach((e: any) => { ids.push(e.grupa_id)});
         this.setState({headersIds: ids, headers: data });
       
        let load = true;
        ids.forEach((e: any) => {
          load = true;
          for (let i = 0; i < this.props.page.asort.length; i++) {
            if(this.props.page.asort[i][0].grupa_id == e){
              load = false;
              break;
            }
          }    
          if(load){
            this.getAsortData(e)
          }      
        });
      };
    
      async getAsortData(id: number) {
        MenuService.getAsortFoto({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")), aGrupaId: id }, {})
          .then(
            (res : any) => {
              //console.log(res.result)
              store.dispatch(Actions.pageState.getAsort(res.result));
              }
            )        
          .catch( (err : any) => {
            console.error
            } 
          );
      }

    //   getBlob = () => {
    //     this.props.page.asort[0].forEach((x: any) => {this.getBlobData(x.asort_id)});
    //   }

    //   getBlobData = async (id: number) => {
    //     try {
    //       let res = await BlobService.dajBlob1({
    //         aJSON: {
    //           hotelId: CONFIG.hotelID,
    //           ajsonBlob: '',
    //           ajsonRekNr: id,
    //           ajsonWebService: CONFIG.hotelID,
    //           opis: '',
    //         }}, { })

    //     if(res.result){
    //       let data = this.state.blobData
    //       data.push(res.result[0])
    //       this.setState({blobData: data})
    //     }

    //   } catch(error) {
    //     //await sendErrorLog( "0", "-1", '/obiekt/blobZmien')
    //     //await store.dispatch(Actions.pageState.addFcmLogMessage('/obiekt/blobZmien', 2))
    //     console.log(error);
    //   }
    // }

    render() {
      const classes = this.props.classes;

      //console.log(this.props.page.asort)

      let header = this.state.headers; 
      let data: any = [] 
      let asort: any = []
      header.forEach((e: any) => {
        data = this.props.page.asort.filter((el: any) => el[0].grupa_id == e.grupa_id);   
        asort.push(this.flat(data));
      });


            
      return(
        <Fragment>
          <div style={{ width: "100%", textAlign: "end", margin: "-20px 0px 5px 0px" }}>
            <IconButton
              className={classes.iconButton}
              onClick={() => this.setView(1)}
            >
              <MenuIcon className={classes.icon} />
            </IconButton>
            <IconButton
              className={classes.iconButton}
              onClick={() => this.setView(2)}
            >
              <AppsIcon className={classes.icon} />
            </IconButton>
          </div>

          {this.state.view === 1 && asort[0]? asort[0].map((danie1: AsortGrupyWiersz, index: number) => (
            <KartaDanie 
              danie = { danie1 }
              key={ danie1.asort_id }
              view={this.state.view}
              //lang={this.props.page.lang}
              ostatni={asort && asort[0].length === index +1}
              setItem={this.setItem}
            />
          )) : this.state.view === 2 && asort[0]?
           <Grid container spacing={4} >
            {asort[0].map((danie1: AsortGrupyWiersz, index: number) => (
            <KartaDanie 
              danie = { danie1 }
              key={ danie1.asort_id }
              view={this.state.view}
              //lang={this.props.page.lang}
              ostatni={asort && asort[0].length === index +1}
              setItem={this.setItem}
            />
            )) }
         </Grid> : <div style={{width: "100%", textAlign: "center"}}><CircularProgress className={classes.progress}/></div> }
          
         

        </Fragment>
      )
    }
  }

const styles = (theme : Theme) => ({
  progress: { 
    margin: theme.spacing(2) 
  },
  iconButton: {
    padding: "4px"
  },
  icon: {
    width: "0.6em !important",
    height: "0.6em !important",
  }
});
  
const mapStateToProps = (state : AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(Zamowienie));